import * as React from 'react'
import Modal from '../../../ui/Modal'
import { IGoinZoneObject } from 'src/types'

export interface IRemoveZoneModalProps {
  onClose: () => void
  onRemove: (zone: IGoinZoneObject) => Promise<any>
  zones: { [key: number]: IGoinZoneObject }
}

interface IRemoveZoneModalState {
  isPending: boolean
  error: string
  newOption: string
}

class RemoveZoneModal extends React.Component<any, IRemoveZoneModalState> {
  constructor(props: IRemoveZoneModalProps) {
    super(props)
  }

  public render() {
    const zone: IGoinZoneObject = this.props.zones[this.props.match.params.id]
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='MobilityOptionsModalAddTitle font-small weight-300 font-grey2'>ARE YOU SURE?</span>

            <div>
              <div className='h3'>Are you sure want to remove </div>
              <div className='h3 bold'>{zone ? zone.name : ''}</div>
              <div>From {zone ? zone.zoneType : ''}?</div>
            </div>

            <div className='flex'>
              <div style={{ marginLeft: 'auto' }}>
                <div onClick={this.handleCancelClick} className='btn bg-green font-white rounded ml1'>
                  Close
                </div>
                <div onClick={this.handleRemoveClick} className='btn bg-red font-white rounded ml1'>
                  Remove
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleRemoveClick = () => {
    this.props.onClose()
    const zone = this.props.zones[this.props.match.params.id]
    this.props.onRemove(zone)
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default RemoveZoneModal



// WEBPACK FOOTER //
// ./src/components/services/edit/goinzones/RemoveZoneModal.tsx